export const CheckingSession = 0;
export const NotLogged = 1;
export const LoggedIn = 2;
export const LoginFailed = 3;
export const UnkownSession = 4;
export const SessionEnded = 5;
export const SessionPaused = 6;